import { useEffect, useState } from 'react';
import { useDebounce } from 'react-use';

import { Box, Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

import isEmpty from 'lodash/isEmpty';
import { useDeviceInfo } from 'src/hooks/useDeviceInfo';

function AppVersion() {
    const deviceInfo = useDeviceInfo();
    const { lastUpdatedTimestamp, ...storedDeviceInfo } = deviceInfo || {};

    const [showDeviceInfo, setShowDeviceInfo] = useState(false);
    const [tapCount, setTapCount] = useState(0);

    const resetTapCount = () => {
        setTapCount(0);
    };
    useDebounce(resetTapCount, 500, [tapCount]);

    const incrementTapCount = () => {
        setTapCount((prev) => prev + 1);
    };

    const handleCloseDeviceDetails = () => {
        setShowDeviceInfo(false);
    };

    useEffect(() => {
        if (tapCount >= 5) {
            setShowDeviceInfo(true);
        }
    }, [tapCount]);

    return (
        <>
            <Box sx={{ width: '100%', textAlign: 'center', py: 2.5 }}>
                <Typography
                    variant="body1"
                    align="center"
                    sx={{ color: 'grey.500' }}
                    onClick={incrementTapCount}
                >
                    App Version {import.meta.env.VITE_VERSION}
                </Typography>
            </Box>

            <Dialog open={showDeviceInfo} onClose={handleCloseDeviceDetails}>
                <DialogTitle>Device Information</DialogTitle>
                <DialogContent>
                    {isEmpty(storedDeviceInfo) ? (
                        <Typography variant="body2" sx={{ color: 'grey.500', mt: 2 }}>
                            No device information available.
                        </Typography>
                    ) : (
                        <Stack sx={{ gap: 1.5, mt: 2 }}>
                            <Box
                                component="dl"
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                    gap: 2,
                                    m: 0,
                                }}
                            >
                                {Object.entries(storedDeviceInfo).map(([key, value]) => (
                                    <Box key={key}>
                                        <Typography
                                            component="dt"
                                            variant="caption"
                                            sx={{ color: 'grey.600' }}
                                        >
                                            {key}
                                        </Typography>
                                        <Typography
                                            component="dd"
                                            variant="body2"
                                            sx={{ fontWeight: 'bold', m: 0 }}
                                        >
                                            {value}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>

                            {lastUpdatedTimestamp && (
                                <Typography variant="caption" sx={{ color: 'grey.500' }}>
                                    Last updated: {new Date(lastUpdatedTimestamp).toLocaleString()}
                                </Typography>
                            )}
                        </Stack>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
}

export default AppVersion;
